<template>
    <section v-if="regions">
        <div class="container">
            <div class="row">
                <article class="m-cardcomponent" v-for="region in regions" :key="region.Id">
                    <div class="region-card">
                        <a 
                            v-on:click.prevent="RegionSelected(region.Id)" 
                            data-toggle="tab" 
                            href="#list-tab-panel" 
                            class="region-card__link" 
                            :aria-labelledby="'region-list-item-' + region.Id">

                            <div class="image">
                                <thumbnail-image :photo-id="region.Thumbnail"></thumbnail-image>
                                <div class="summary" v-if="region.Summary">
                                    <p>
                                        {{region.Summary}}
                                    </p>
                                </div>
                            </div>

                            <div class="region-card__text">
                                <div class="icon-roundal region-card__roundal">
                                    <svg aria-hidden="true" class="icon icon--s">
                                        <use xlink:href="/icons/sprite.svg#chevron-right"></use>
                                    </svg>
                                </div>
                                <span :id="'region-list-item-' + region.Id" class="region-card__title">{{region.Name}}</span>
                            </div>

                        </a>
                    </div>
                </article>
            </div>
        </div>
    </section>
</template>

<script>
    import Axios from 'axios'
    import ThumbnailImage from '@/components/Utils/thumbnail-image'

    import { searchMixin } from '@/mixins/searchMixin.js'

    export default {
        components: {
            ThumbnailImage
        },

        computed: {
            isLoading() {
                return this.$store.getters.isLoading
            },
            
            regions: function () {
                return this.$store.state.search.regions
            }
        },

        created: function () {
            this.Init()
        },

        data() {
            return {
                searchApiUrl: '/umbraco/api/PropertySearchApi/Search'
            }
        },

        methods: {
            Init: function () {
                var vm = this

                const getRegions = function () {
                    return Axios.get('/umbraco/api/PropertySearchApi/Regions', { params: { currentPageId: currentPageId } })
                }

                Axios.all([getRegions()])
                    .then(Axios.spread(function (response) {
                        if (response.data && response.data.length > 0) {
                            vm.$store.dispatch('updateSearchRegions', response.data)
                        }
                    }))
                    .catch((error) => {
                        console.error('Search request failed:', error)
                    })
            },

            RegionSelected: function (regionId) {
                console.log('Fetch filtered Data: Loading state', this.$store.state.loading)
                this.$store.dispatch('updateSearchFilter', { key: 'filter_16738', value: [regionId] })
                this.$eventHub.$emit('search-regionSelected')
                this.search(true)
            }
        },

        mixins: [searchMixin]
    }
</script>